export interface ActiviteInterne {
  id_intervenant: string;
  matricule: string;
  id_tempo: string;
  type_activite_interne_planifiee: string;
  planification_date_debut: Date;
  planification_date_fin: Date;
}

export class CrActiviteInterne {
  type: 'cr-activite-interne';
  id?: string;
  id_activite_interne: string;
  cr_commentaire_intervenant: string;
  cr_type_activite_realisee: TypeActiviteInterne;
  cr_activite_interne_date_debut: string;
  cr_activite_interne_date_fin: string;
  cr_activite_interne_duree: number;
  cr_activite_interne_duree_in_seconds?: number;
  cr_deplacement_date_debut: string;
  cr_deplacement_date_fin: string;
  cr_deplacement_duree: number;
  cr_deplacement_duree_in_seconds?: number;
  cr_duree_totale: number;
  cr_duree_totale_in_seconds?: number;
  etat?: EtatActiviteInterne;
  idTempo?: string;
  estRenfort: boolean;
  numero_ot?: string;
  libelle_site?: string;
  dk_code_site?: string;

  constructor() {
    this.type = 'cr-activite-interne';
  }
}

export enum TypeActiviteInterne {
  Causeries = 'Causeries',
  Delegation = 'Délégation',
  EntretienProfessionnel = 'Entretien professionnel',
  Formation = 'Formation',
  GestionVehicule = 'Gestion véhicule',
  OutillageEquipement = 'Outillage/Equipement',
  ReunionsInternes = 'Réunions internes',
  TravailAuBureau = 'Travail au bureau',
  VisiteMedicale = 'Visite médicale',
  Renfort = 'Renfort',
}

export enum EtatActiviteInterne {
  ErreurEnvoi = "Erreur d'envoi",
  Envoye = 'Envoyé',
  ErreurServeur = 'Erreur serveur',
  EnCours = "En cours d'envoi",
}

export interface CrActiviteInterneFilter {
  id_intervenant: string;
  saisi_apres_date: string;
  saisi_avant_date: string;
}
